import { useMutation } from 'react-query';

import { QueryParams, updateReportTemplate as mutationFn } from 'api/endPoints/UpdateReportTemplate';
import { QueryResponse as Tag } from 'api/queries/getReportsTags.query';

export const useMutationEditReportTemplate = () => {
    return useMutation<MutationResponse, QueryError, QueryParams>((params) => mutationFn(params));
};

interface MutationResponse {
    id: number;
    name: string;
    description: string;
    tags: Tag[];
}
